@if (formStatus | async; as state) {
  @if (state === actionState.READY) {
    <form [formGroup]="configForm" (keydown.enter)="$event.preventDefault()" id="configForm">
      <h2 (click)="isCollapsed = !isCollapsed" class="p-20">
        {{'stations.form.connectionGir' | translate}}
        @if (f.name.value.length > 0) {
          : {{f.name.value}}
        }
        <i class="chevron icon-chevron-down icon-collapse" [class.d-none]="isCollapsed === false"></i>
        <i class="chevron icon-chevron-up icon-collapse" [class.d-none]="isCollapsed === true"></i>
      </h2>
      @if (!isCollapsed) {
        <div class="pb-20 px-20">
          <hr class="first-hr">
          <h3>{{'stations.form.technical_details' | translate}}</h3>
          <div class="field-group d-flex flex-wrap">
            <div class="col-3">
              <!-- NAME -->
              <div class="form-group">
                <label for="name" class="required">{{'stations.form.label.girConnexion.name' | translate}}</label>
                <input formControlName="name" type="text" class="form-control" id="name"
                  [placeholder]="'stations.form.placeholder.girConnexion.name' | translate">
                @if (f.name.invalid && (f.name.dirty || f.name.touched)) {
                  <div class="alert alert-danger">
                    @if (f.name.errors.required) {
                      <div>
                        {{'error.is_required' | translate}}
                      </div>
                    }
                  </div>
                }
              </div>
              <!-- CONNEXION STATE -->
              @if (config?.state) {
                <div class="form-group">
                  <label>{{'stations.form.label.connection_state' | translate}}</label>
                  <div class="text-uppercase">
                    <i class="connection-state {{config.state.toLowerCase()}}"></i>
                    {{'stations.connection_state.' + config.state | translate}}
                  </div>
                </div>
              }
            </div>
            <div class="col-3">
              <!-- SITE ID -->
              <div class="form-group">
                <label for="externalSiteId" class="required">{{'stations.form.label.girConnexion.externalSiteId' | translate}}</label>
                <input formControlName="externalSiteId" type="text" class="form-control" id="externalSiteId"
                  [placeholder]="'stations.form.placeholder.girConnexion.externalSiteId' | translate">
                @if (f.externalSiteId.invalid && (f.externalSiteId.dirty || f.externalSiteId.touched)) {
                  <div class="alert alert-danger">
                    @if (f.externalSiteId.errors.required) {
                      <div>
                        {{'error.is_required' | translate}}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="col-3">
              <!-- ZONE ID -->
              <div class="form-group">
                <label for="externalZoneId" class="required">{{'stations.form.label.girConnexion.externalZoneId' | translate}}</label>
                <input formControlName="externalZoneId" type="text" class="form-control" id="externalZoneId"
                  [placeholder]="'stations.form.placeholder.girConnexion.externalZoneId' | translate">
                @if (f.externalZoneId.invalid && (f.externalZoneId.dirty || f.externalZoneId.touched)) {
                  <div class="alert alert-danger">
                    @if (f.externalZoneId.errors.required) {
                      <div>
                        {{'error.is_required' | translate}}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <!-- DELETE -->
                <label>&nbsp;</label>
                @if (!creationView && config.uid) {
                  <a href="javascript:void(0);" class="delete-config text--danger" [ngClass]="{'disabled': !isEditting}" (click)="onDeleteConfig()">
                    {{'action.delete_config' | translate }}
                  </a>
                }
              </div>
            </div>
          </div>
          <div class="btn__ctn text-right">
            @if (!isEditting) {
              <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--primary" type="button" (click)="toggleEdition()"
                >
                {{'action.edit' | translate}}
              </button>
            } @else {
              <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--primary mr-20" type="button" (click)="onSubmit()">
                {{'action.submit' | translate}}
              </button>
              @if (!creationView && !config.newConnection) {
                <button [appReadWrite]="FEATURE.SITE_MANAGEMENT" class="btn btn--outline-grey-color" type="button" (click)="toggleEdition(true)"
                  >
                  {{'action.cancel' | translate}}
                </button>
              }
            }
          </div>
        </div>
      }
    </form>
  }
}